// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".profile-page{text-align:center}.profile-card{margin-bottom:1rem}.profile-form{margin-bottom:1rem;text-align:left}\n", ""]);
// Exports
module.exports = exports;
